import { createSlice } from "@reduxjs/toolkit";

const addModalFinancialBalanceSlice = createSlice({
  name: "addModalFinancialBalance",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalFinancialBalanceSlice.actions;
export default addModalFinancialBalanceSlice.reducer;
